import { z } from "zod";

/**
 * Coordinate schemas
 */
export const latitudeSchema = z
  .number({
    error: "Please enter a latitude",
  })
  .min(-90, "Latitude must be between -90 and 90")
  .max(90, "Latitude must be between -90 and 90");

export const longitudeSchema = z
  .number({
    error: "Please enter a longitude",
  })
  .min(-180, "Longitude must be between -180 and 180")
  .max(180, "Longitude must be between -180 and 180");

/**
 * Position schema
 */
export const positionSchema = z.object({
  latitude: latitudeSchema,
  longitude: longitudeSchema,
});

/**
 * Example platform schema
 */
export const platformSchema = z.object({
  position: positionSchema,
});

/**
 * Types
 */
export type Position = z.infer<typeof positionSchema>;
